import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

declare var zxcvbn;

@Component({
   selector: 'password-strength',
   templateUrl: './password-strength.html',
   styleUrls: ['./password-strength.css'],
   encapsulation: ViewEncapsulation.None,
   preserveWhitespaces: false
})
export class PasswordStrengthComponent {
   @HostBinding('class.password-strength') _ = true;
   private scoreText = ['risky', 'weak', 'fair', 'strong', 'excellent'];
   score: number;
   text = '';
   css = ['', '', '', '', ''];
   @Input() minlength: number;
   error: string;

   constructor(private translate: TranslateService) { }
   eval(password: string, username = '', name = ''): number {
      let tempUser = username;
      tempUser = tempUser.split('@')[0];

      if (password) {
         if ((username && password.toLowerCase().indexOf(username.toLowerCase()) !== -1)
            || (tempUser && password.toLowerCase().indexOf(tempUser.toLowerCase()) !== -1)
            || (name && password.toLowerCase().indexOf(name.toLowerCase()) !== -1)) {
            this.score = 0;
            this.translate.get('pwd-strength.contains').subscribe(s => this.error = s);
         } else {
            const result = zxcvbn(password);
            this.score = result.score;
            if (password.length < this.minlength) {
               this.translate.get('pwd-strength.least', {char: this.minlength}).subscribe(s => this.error = s);
            } else {
               if (this.score < 2) {
                  this.translate.get('pwd-strength.mix').subscribe(s => this.error = s);
               } else {
                  this.error = '';
               }
            }
         }
      } else {
         this.score = 0;
         this.translate.get('pwd-strength.least', {char: this.minlength}).subscribe(s => this.error = s);
      }

      this.text = this.score >= 0 && this.score < this.scoreText.length ? this.scoreText[this.score] : '';
      this.translate.get(`pwd-strength.${this.text}`).subscribe(s => this.text = s);
      const level = this.score >= 0 && this.score < this.css.length ? `l${this.score}` : '';
      for (let i = 0; i < this.css.length; i++) {
         this.css[i] = this.score >= i ? level : null;
      }
      return this.score;
   }
}
